// Defaults for newly entered values, not a claim of independent verification.
export function inferIdentityQuality(kind, values) {
  const present = Object.values(values).some(value => value.trim() !== "");
  if (!present) return "";
  if (kind === "name") return values.first_name?.trim() && values.last_name?.trim() ? "1" : "2";
  if (kind === "date_of_birth") return "1";

  const ssn = values.ssn.trim();
  if (/^\d{4}$/.test(ssn)) return "2";
  const digits = ssn.replaceAll("-", "");
  const validFormat = /^\d{9}$/.test(ssn) || /^\d{3}-\d{2}-\d{4}$/.test(ssn);
  return validFormat && /^(?!000|666|9)\d{3}(?!00)\d{2}(?!0000)\d{4}$/.test(digits) ? "1" : "";
}
